import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IDeleteEmployeesRequest } from '../models/delete.employees.model';

export const loadDeleteEmployees = createAction('[DeleteEmployee] Load DeleteEmployees', props<{ request: IDeleteEmployeesRequest }>());

export const loadDeleteEmployeesSuccess = createAction('[DeleteEmployee] Load DeleteEmployees Success', props<{ response: string }>());

export const loadDeleteEmployeesFailure = createAction(
  '[DeleteEmployee] Load DeleteEmployees Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
